import { render, staticRenderFns } from "./backup_and_repair.vue?vue&type=template&id=560aace5&"
import script from "./backup_and_repair.vue?vue&type=script&lang=js&"
export * from "./backup_and_repair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports